const Marquee = () => {
  const text = "FULL SEND — RUGGED OUTDOOR WEAR — 1500 KSH — DROP 01 — ";
  const items = Array(6).fill(text);
  return (
    <div className="border-y border-[var(--line)] bg-[var(--accent)] py-4 overflow-hidden">
      <div className="marquee-track">
        {items.concat(items).map((t, i) => (
          <span
            key={i}
            className="font-anton uppercase text-white text-2xl md:text-4xl tracking-tight px-4"
          >
            {t}
          </span>
        ))}
      </div>
    </div>
  );
};

export default Marquee;
